import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import CompanyProcessActions, { CompanyProcessTypes } from '../Stores/CompanyProcess/Actions';

// const getAppStore = state => state.app;

export function* companyProcessFetchCompanyProcess() {
  try {
    yield put(CompanyProcessActions.companyProcessFetchCompanyProcessLoading(true));

    const result = [{ proc_type: 'COMPANY_LIST_01', icon: 'fa fa-cubes' }];
    yield put(CompanyProcessActions.companyProcessFetchCompanyProcessSuccess(result));

    /*
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `company/indexItemFlow/${companyFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    
    if (result.isSuccess === true) {
      yield put(CompanyProcessActions.companyProcessFetchCompanyProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
    */
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CompanyProcessActions.companyProcessFetchCompanyProcessLoading(false));
  }
}

export const saga = [
  takeLatest(
    CompanyProcessTypes.COMPANY_PROCESS_FETCH_COMPANY_PROCESS,
    companyProcessFetchCompanyProcess
  )
];
